var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Pricing.PriceSetting"),
        width: "1000px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "fcl-setting-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "tabs-container",
          staticStyle: { flex: "1", overflow: "hidden", "padding-bottom": "0" }
        },
        [
          _vm.innerVisible
            ? _c(
                "el-tabs",
                {
                  ref: "tabs",
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: { label: _vm.$t("Pricing.Markup"), name: "markup" }
                    },
                    [
                      _c("tab-air-approve-settings", {
                        ref: "markup",
                        on: { close: _vm.onCancel }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }